import { render, staticRenderFns } from "./salaryHistory.vue?vue&type=template&id=75691a6b"
import script from "./salaryHistory.vue?vue&type=script&lang=js"
export * from "./salaryHistory.vue?vue&type=script&lang=js"
import style0 from "./salaryHistory.vue?vue&type=style&index=0&id=75691a6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports